import React from 'react';
import DepartmentTemplate from './DepartmentTemplate';

const DeptYvelines78 = () => {
  return (
    <DepartmentTemplate
      department="Yvelines"
      departmentNumber="78"
      cities="Versailles, Saint-Germain-en-Laye, Poissy, Mantes-la-Jolie"
      region="Île-de-France"
    />
  );
};

export default DeptYvelines78;
